import { render, staticRenderFns } from "./FormResult.vue?vue&type=template&id=2b0135f2&scoped=true"
import script from "./FormResult.vue?vue&type=script&lang=js"
export * from "./FormResult.vue?vue&type=script&lang=js"
import style0 from "./FormResult.vue?vue&type=style&index=0&id=2b0135f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0135f2",
  null
  
)

export default component.exports